import { electronModule } from "@/modules/electron";
import {
  DesktopAudioWaveformUpdateEvent,
  DesktopRecallRealtimeEventPayload,
} from "@/modules/electron/types";
import { DesktopWaveformUpdate } from "@/modules/audio-recording/desktop-waveform-update";
import { parseDesktopRealtimeEnvelope, ParsedDesktopEvent } from "./desktop-event-parser";

export type DesktopEventListener = (event: ParsedDesktopEvent) => void;
export type DesktopWaveformListener = (args: {
  audioRecordingId: string;
  update: DesktopWaveformUpdate;
}) => void;

export function subscribeDesktopRealtime(listener: DesktopEventListener): () => void {
  let unsubscribe: (() => void) | undefined;

  const callback = ({ event, kind }: DesktopRecallRealtimeEventPayload) => {
    const parsed = parseDesktopRealtimeEnvelope({ event, kind });
    if (!parsed) {
      return;
    }

    listener(parsed);
  };

  try {
    unsubscribe = electronModule.recall.onEvent?.({ callback });
  } catch (_) {
    // bridge not available
  }

  return () => {
    try {
      unsubscribe?.();
    } catch (_) {
      /* empty */
    }
  };
}

export function subscribeDesktopWaveformUpdates(listener: DesktopWaveformListener): () => void {
  let unsubscribe: (() => void) | undefined;

  const callback = ({ audioRecordingId, update }: DesktopAudioWaveformUpdateEvent) => {
    listener({
      audioRecordingId,
      update,
    });
  };

  try {
    unsubscribe = electronModule.audioWaveform.onUpdate?.({ callback });
  } catch (_) {
    // bridge not available
  }

  return () => {
    try {
      unsubscribe?.();
    } catch (_) {
      /* empty */
    }
  };
}
